import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Parallax } from "react-parallax";
import Navbar from '../layout/Navbar';
import Preloader from '../layout/preloader';
import CadastroAtletaFormulario from '../section-pages/cadastro-atleta-formulario';
import Footer from '../section-pages/footer';
import ScrollToTopBtn from '../layout/ScrollToTop';
import { createGlobalStyle } from 'styled-components';
import ApiAcademias from '../services/academiaService';

const image1 = "../../img/background/space.webp";

const GlobalStyles = createGlobalStyle`
  .react-parallax-bgimage {
    transform: translate3d(-50%, -12%, 0px) !important;
  }
`;

export default function CadastrarAtleta() {

  const [academias, setAcademias] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchAcademias = async () => {
    try {
      const response = await ApiAcademias.listar();
      setAcademias(response.data.academias);
    } catch (error) {
      console.error('Erro ao buscar academias:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
      if (typeof window !== 'undefined') {
          const loader = document.getElementById('mainpreloader');
          if (loader)
          setTimeout(() => {
            loader.classList.add("fadeOut");
            loader.style.display = 'none';
          }, 600)
      }
      fetchAcademias();
    }, []);
  return (
    <>
    {/* HEAD */}
    <Helmet>
      <link rel="icon" href="./img/icon.png" />
      <title>Fetron - Federação de Taekwondô de Rondônia</title>
    </Helmet>

    <GlobalStyles/>

    {/* LOADER */}
    <div id='mainpreloader'>
      <Preloader/>
    </div>

    {/* MENU */}
    <div className="home dark-scheme">
      <header id="header-wrap">
         <Navbar />
      </header>

      {/* section */}
      <Parallax className="" bgImage={image1} strength={300}>  
        <section className="no-bg">
          <div className="container z-9">
              <div className="row">
                  <div className="col-lg-12">
                      <h3 className="wow fadeInUp mb-3">Cadastro de Atleta</h3>
                  </div>
              </div>
          </div>
        </section>
      </Parallax>

      {/* section */}
      <section>
        <CadastroAtletaFormulario academias={academias}/>
      </section>

      {/* footer */}
      <Footer/>


    </div>
    <ScrollToTopBtn />
    </>
  )
}
